"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentUpdateProposalSchema = exports.documentEditSchema = exports.attachmentInfoSchema = exports.httpAttachmentSchema = exports.documentStatusSchema = exports.attachmentSchema = exports.generatedDocumentMetadataSchema = exports.attachmentReferenceSchema = void 0;
exports.createTekkrFileUrl = createTekkrFileUrl;
exports.parseTekkrFileUrl = parseTekkrFileUrl;
const zod_1 = require("zod");
const enums_1 = require("../enums");
exports.attachmentReferenceSchema = zod_1.z.discriminatedUnion("type", [
    zod_1.z.strictObject({
        type: zod_1.z.literal(enums_1.AttachmentReferenceType.URL),
        url: zod_1.z.string(),
        name: zod_1.z.string(),
    }),
    zod_1.z.strictObject({
        type: zod_1.z.literal(enums_1.AttachmentReferenceType.File),
        fileId: zod_1.z.string(),
    }),
]);
exports.generatedDocumentMetadataSchema = zod_1.z.strictObject({
    originalContent: zod_1.z.string(),
    contentSummary: zod_1.z.string(),
    generatedAt: zod_1.z.string(),
    lastCheckedForChangesAt: zod_1.z.string().optional(),
    updateStatus: zod_1.z.enum(["up-to-date", "stale", "pending-review"]),
});
exports.attachmentSchema = zod_1.z.strictObject({
    id: zod_1.z.string(),
    target: zod_1.z.array(zod_1.z.string()).optional(),
    reference: exports.attachmentReferenceSchema,
    createdBy: zod_1.z.string(),
    createdAt: zod_1.z.string(),
    metadata: exports.generatedDocumentMetadataSchema.optional(),
});
exports.documentStatusSchema = zod_1.z.strictObject({
    updateStatus: zod_1.z.enum(["up-to-date", "stale", "pending-review"]),
    generatedAt: zod_1.z.string(),
    lastCheckedForChangesAt: zod_1.z.string().optional(),
});
exports.httpAttachmentSchema = exports.attachmentSchema
    .omit({ metadata: true })
    .extend({
    name: zod_1.z.string(),
    documentStatus: exports.documentStatusSchema.optional(),
})
    .strict();
exports.attachmentInfoSchema = exports.attachmentSchema.omit({ reference: true, target: true, createdBy: true }).extend({
    name: zod_1.z.string(),
    url: zod_1.z.string().optional(),
});
function createTekkrFileUrl(fileId) {
    return `tekkr-file://${fileId}`;
}
function parseTekkrFileUrl(url) {
    if (!url.startsWith("tekkr-file://")) {
        return null;
    }
    return url.match(/^tekkr-file:\/\/(?<fileId>.+)$/)?.groups;
}
exports.documentEditSchema = zod_1.z.strictObject({
    id: zod_1.z.string(),
    searchText: zod_1.z.string(),
    replaceText: zod_1.z.string(),
    reason: zod_1.z.string(),
    applicable: zod_1.z.boolean(),
});
exports.documentUpdateProposalSchema = zod_1.z.strictObject({
    proposalId: zod_1.z.string(),
    projectId: zod_1.z.string(),
    attachmentId: zod_1.z.string(),
    documentName: zod_1.z.string(),
    edits: zod_1.z.array(exports.documentEditSchema),
    userChangesDetected: zod_1.z.boolean(),
    changeSummary: zod_1.z.string(),
    createdAt: zod_1.z.string(),
});
